import CustomIcon, { ICustomIconProps } from '../_CustomIcon';
import IconComponent from './Icon.svg';

const PlusCircleIcon = (props: ICustomIconProps) => <CustomIcon icon={IconComponent} {...props} />;

export default PlusCircleIcon;
